import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { statusCode, progressReportStatus } from '../../../../app/auth/models/commonEnum';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { MyApplicationService } from '../my-application.service';
import { DatePipe, formatDate } from '@angular/common';
import { first } from 'rxjs/operators';
import moment from 'moment';

@Component({
	selector: 'app-progress-report',
	templateUrl: './progress-report.component.html',
	styleUrls: ['./progress-report.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ProgressReportComponent implements OnInit {
	public contentHeader: object;
	public ID: string;
	public applicationDetail: any;
	public form1_data: any;
	public projectTitle: string;
	public principleInvestigator: string;
	public sanctionDetails: any;
	public orderNo: string;
	public sanctionDate: string;
	public sanctionAmount: string;
	public createdDate: string;
	public endDate: string;
	public documentFiles: any = [];
	public documentFilesSOE: any = [];
	public documentFilesTechnical: any = [];
	public documentFilesOthers: any = [];
	public isDisabled = false;
	public submitted = false;
	public loading = false;
	public reportDetails: any = [];
	public progressReportStatus = progressReportStatus;
	public equipmentDetails: any = [];
	public manPowerDetails: any = [];
	public position = [
		{ positionName: "Yes" },
		{ positionName: "No" },
	];
	otherDocument: any;
	technicalReport: any;
	UCletter: any;
	SOEletter: any;
	releasedReportDetails: any;
	constructor(private fb: FormBuilder,
		private _router: Router,
		private datePipe: DatePipe,
		private _formBuilder: FormBuilder,
		private router: Router,
		private route: ActivatedRoute,
		private _myApplicationService: MyApplicationService,
		private toastr: ToastrService) {
		this.progressReportForm = this._formBuilder.group({
			Projecttitles: [null],
			nameOfPi: [null],
			addressOfPi: [null, [Validators.required]],
			projectstartDate: [null],
			projectendDate: [null],
			sanctionOrderNo: [null],
			sanctionOrderDate: [null],
			sanctionAmount: [null],
			actualExpenditure: [null, [Validators.required]],
			approvedObject: [null, [Validators.required]],
			outputProject: [null, [Validators.required]],
			summary: [null, [Validators.required]],
			detailedProgress: [null, [Validators.required]],
			technicalReport: [null,],
			technicalReportName:[],
			otherDocument: [null, ],
			otherDocumentName: [null],
			newObservation: [null, [Validators.required]],
			innovations: [null, [Validators.required]],
			applicationPotential: [null, [Validators.required]],
			projectWorkPlan: [null, [Validators.required]],
			financialStatus: [null],
			UCLatter: [null, ],
			UCLatterName: [null, [Validators.required]],
			SOELatter: [null, ],
			SOELatterName: [null, [Validators.required]]
		});
		this.route.params.subscribe(parmas => {
			this.ID = parmas["id"];
		});
	}
	public progressReportForm: FormGroup;
	public totalFundsForm: FormGroup;
	public equipmentProcurementForm: FormGroup;
	public manpowerForm: FormGroup;
	ngOnInit(): void {
		this.getApplicationDetail(this.ID);
		this.getProgressReportDetails(this.ID);
		this.contentHeader = {
			headerTitle: 'Progress Report',
			actionButton: true,
			breadcrumb: {
				type: '',
				links: [
					{
						name: 'My Application',
						isLink: true,
						link: '/'
					},
					{
						name: 'Progress Report',
						isLink: false
					},
				]
			}
		};
		this.equipmentProcurementForm = new FormGroup({
			equipmentProcurementArray: this._formBuilder.array([
				// this._formBuilder.group({
				// 	sanctionitem: [null, [Validators.required]],
				// 	procurementStatus: [null, [Validators.required]],
				// 	cost: [null, [Validators.required]],
				// 	workingOrNot: [null, [Validators.required]],
				// 	remarks: [null, [Validators.required]]
				// })
			])
		});
		this.manpowerForm = new FormGroup({
			manpowerArray: this._formBuilder.array([
				// this._formBuilder.group({
				// 	sanctionedlist: [null, [Validators.required]],
				// 	position: [null, [Validators.required]],
				// 	scale: [null, [Validators.required]],
				// 	manpowerRemarks: [null, [Validators.required]]
				// })
			])
		});
		this.progressReportForm.controls.UCLatterName.setValue("Select file");
		this.progressReportForm.controls.SOELatterName.setValue("Select file");
		this.progressReportForm.controls.technicalReportName.setValue("Select file");
		this.progressReportForm.controls.otherDocumentName.setValue("Select file");
	}

	isValidData(data){
		if(data != null && data != undefined && data != ''){
			return true;
		}
		return false;
	}

	getApplicationDetail(id) {
		const data = {
			applyonlineId: id
		}
		this._myApplicationService.getApplicationDetail(data).subscribe((result: any) => {
			this.applicationDetail = null;
			if (result.statusCode == statusCode.SUCCESS) {
				this.applicationDetail = result["data"]["response"];
				this.form1_data = this.applicationDetail.form1_data;
				this.projectTitle = this.form1_data.projectTitle;
				this.principleInvestigator = this.form1_data.principleInvestigator;
			}
		})
		this._myApplicationService.getSanctionDetials(data).subscribe((result: any) => {
			if (result.statusCode == statusCode.SUCCESS) {
				this.sanctionDetails = result["data"]["response"];
				this.orderNo = this.sanctionDetails.orderNo;
				let [year, month, day] = ['','',''];
				let obj = null;
				this.sanctionDate = this.sanctionDetails.sanctionDate;
				if(this.isValidData(this.sanctionDate)){
					[year, month, day] = this.sanctionDate.split('-');
				obj = { year: parseInt(year), month: parseInt(month), day: 
					parseInt(day.split(' ')[0].trim()) };
				this.progressReportForm.controls.sanctionOrderDate.setValue(obj);
				}
				this.createdDate = this.sanctionDetails.createdDate;
				if(this.isValidData(this.createdDate)){
					[year, month, day] = this.createdDate.split('-');
				obj = { year: parseInt(year), month: parseInt(month), day: 
				  parseInt(day.split(' ')[0].trim()) };
				this.progressReportForm.controls.projectstartDate.setValue(obj);
				}
				this.endDate = this.sanctionDetails.endDate;
				if(this.isValidData(this.endDate)){
					[year, month, day] = this.endDate.split('-');
				obj = { year: parseInt(year), month: parseInt(month), day: 
				  parseInt(day.split(' ')[0].trim()) };
				  this.progressReportForm.controls.projectendDate.setValue(obj);
				}
				this.sanctionAmount = this.sanctionDetails.amount;
			}
		})
	}
	addRow() {
		const totalFundArray = <FormArray>this.totalFundsForm.controls['fundArray'];
		if (this.totalFundsForm.status != "INVALID") {
			totalFundArray.push(this.initFundRow());
			this.toastr.success('New row added sucessfully.', 'Success!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
			return true;
		} else {
			this.toastr.info('please fillup the current row details.', 'Info!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
		}
		return false;
	}
	initFundRow(): FormGroup {
		return this._formBuilder.group({
			sanctionNumber: [null, [Validators.required]],
			amount: [null, [Validators.required]],
			sanctionDate: [null, [Validators.required]]
		});
	}
	addEquipmentRow() {
		const equipmentProcurementArray = <FormArray>this.equipmentProcurementForm.controls['equipmentProcurementArray'];
		if (this.equipmentProcurementForm.status != "INVALID") {
			equipmentProcurementArray.push(this.initEquipmentRow());
			this.toastr.success('New row added sucessfully.', 'Success!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
			return true;
		} else {
			this.toastr.info('please fillup the current row details.', 'Info!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
		}
	}
	initEquipmentRow(): FormGroup {
		return this._formBuilder.group({
			sanctionitem: [null, [Validators.required]],
			procurementStatus: ['Yes', [Validators.required]],
			cost: [null, [Validators.required]],
			workingOrNot: ['Yes', [Validators.required]],
			remarks: [null, [Validators.required]]
		});
	}
	addManpowerRow() {
		const manpowersArray = <FormArray>this.manpowerForm.controls['manpowerArray'];

		if (this.manpowerForm.status != "INVALID") {
			manpowersArray.push(this.initManpowerRow());
			this.toastr.success('New row added sucessfully.', 'Success!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
			return true;
		} else {
			this.toastr.info('please fillup the current row details.', 'Info!', {
				positionClass: 'toast-bottom-right',
				toastClass: 'toast ngx-toastr',
				closeButton: true
			});
		}
	}
	initManpowerRow(): FormGroup {
		return this._formBuilder.group({
			sanctionedlist: [null, [Validators.required]],
			position: ['Yes', [Validators.required]],
			scale: [null, [Validators.required]],
			manpowerRemarks: [null, [Validators.required]]
		});
	}
	deleteRow(index) {
		let newthis = this;
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be remove this row!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			customClass: {
				confirmButton: 'btn btn-primary',
				cancelButton: 'btn btn-danger ml-1'
			}
		}).then(function (result) {
			if (result.value) {
				const totalFundArray = <FormArray>newthis.totalFundsForm.controls['fundArray'];
				if (totalFundArray.length == 1) {
					newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return false;
				} else {
					totalFundArray.removeAt(index);
					newthis.toastr.info("Row deleted successfully.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return true;
				}
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				Swal.fire({
					title: 'Cancelled',
					text: 'Your imaginary file is safe :)',
					icon: 'error',
					customClass: {
						confirmButton: 'btn btn-success'
					}
				});
			}
		});
	}
	deleteEquipmentRow(index) {
		let newthis = this;
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be remove this row!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			customClass: {
				confirmButton: 'btn btn-primary',
				cancelButton: 'btn btn-danger ml-1'
			}
		}).then(function (result) {
			if (result.value) {
				const equipmentProcurementArray = <FormArray>newthis.equipmentProcurementForm.controls['equipmentProcurementArray'];
				if (equipmentProcurementArray.length == 1) {
					newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return false;
				} else {
					equipmentProcurementArray.removeAt(index);
					newthis.toastr.info("Row deleted successfully.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return true;
				}
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				Swal.fire({
					title: 'Cancelled',
					text: 'Your imaginary file is safe :)',
					icon: 'error',
					customClass: {
						confirmButton: 'btn btn-success'
					}
				});
			}
		});
	}
	deleteManpowerRow(index) {
		let newthis = this;
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be remove this row!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			customClass: {
				confirmButton: 'btn btn-primary',
				cancelButton: 'btn btn-danger ml-1'
			}
		}).then(function (result) {
			if (result.value) {
				const manpowerArray = <FormArray>newthis.manpowerForm.controls['manpowerArray'];
				if (manpowerArray.length == 1) {
					newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return false;
				} else {
					manpowerArray.removeAt(index);
					newthis.toastr.info("Row deleted successfully.", 'Info!', {
						positionClass: 'toast-bottom-right',
						toastClass: 'toast ngx-toastr',
						closeButton: true
					});
					return true;
				}
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				Swal.fire({
					title: 'Cancelled',
					text: 'Your imaginary file is safe :)',
					icon: 'error',
					customClass: {
						confirmButton: 'btn btn-success'
					}
				});
			}
		});
	}
	/**
	 * function get uploaded file on upload file change.
	 ***/
	uploadFileChange(event: any, fileSize:any) {
		for (var i = 0; i < event.target.files.length; i++) {
			var filetype = event.target.files[i].type;
				if(filetype != 'application/pdf'){
					Swal.fire({
						title: 'Information',
						text: 'Invalid file type. Please upload File with extension: .pdf',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
			var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
			this.documentFiles = [];
			var key = "documentUC";
			this.documentFiles.push({ key: key, file: event.target.files[i] });
			this.progressReportForm.controls.UCLatterName.setValue(this.showFiles(this.documentFiles));
		}
	}
	/**
	 * function return selected file name.
	 ***/
	showFiles(documentList:any) {
		let files = '';
		for (let i = 0; i < documentList.length; i++) {
			files += documentList[i].file.name;
			if (!(documentList.length - 1 === i)) {
				files += ',';
			}
		}
		return files;
	}
	/**
	 * function get uploaded file on upload file change.
	 ***/
	uploadFileChangeSOE(event: any, fileSize:any) {
		for (var i = 0; i < event.target.files.length; i++) {
			var filetype = event.target.files[i].type;
				if(filetype != 'application/pdf'){
					Swal.fire({
						title: 'Information',
						text: 'Invalid file type. Please upload File with extension: .pdf',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
			var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
			this.documentFilesSOE = [];
			var key = "documentSOE";
			this.documentFilesSOE.push({ key: key, file: event.target.files[i] });
			this.progressReportForm.controls.SOELatterName.setValue(this.showFiles(this.documentFilesSOE));
		}
	}

	/**
	 * function get uploaded file on upload file change.
	 ***/
	uploadFileChangeTechnical(event: any, fileSize:any) {
		var filetype = event.target.files[0].type;
				if(filetype != 'application/pdf'){
					Swal.fire({
						title: 'Information',
						text: 'Invalid file type. Please upload File with extension: .pdf',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
		for (var i = 0; i < event.target.files.length; i++) {
			var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}

			this.documentFilesTechnical = [];
			var key = "documentTechnical";
			this.documentFilesTechnical.push({ key: key, file: event.target.files[i] });
			this.progressReportForm.controls.technicalReportName.setValue(this.showFiles(this.documentFilesTechnical));
		}
	}
	
	uploadFileChangeOther(event: any, fileSize: any) {
		for (var i = 0; i < event.target.files.length; i++) {
			var filetype = event.target.files[i].type;
				if(filetype != 'application/pdf'){
					Swal.fire({
						title: 'Information',
						text: 'Invalid file type. Please upload File with extension: .pdf',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
			var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
			this.documentFilesOthers = [];
			var key = "documentOther";
			this.documentFilesOthers.push({ key: key, file: event.target.files[i] });
			this.progressReportForm.controls.otherDocumentName.setValue(this.showFiles(this.documentFilesOthers));
		}
	}

	browsbuttonClick(type){
		if(type=== "technicalReport"){
			this.progressReportForm.controls.technicalReportName.setValue('Select file');
		}
		else if(type=== "otherDocument"){
			this.progressReportForm.controls.otherDocumentName.setValue('Select file');
		}
		else if(type=== "UCLatter"){
			this.progressReportForm.controls.UCLatterName.setValue('Select file');
		}
		else if(type=== "SOELatter"){
			this.progressReportForm.controls.SOELatterName.setValue('Select file');
		}
	}
	
	/**
	 * function save the progress report data.
	 ***/
	saveProgressReportData() {
		const self = this;
		this.isDisabled = true;
		this.submitted = true;
		if (this.progressReportForm.invalid) {
			this.isDisabled = false;
			return false;
		}
		const data = self.prepareSave();
		this.loading = true;
		this._myApplicationService
			.submitProgressData(data).pipe(first())
			.subscribe(
				response => {
					if (Number(response["statusCode"]) === statusCode.SUCCESS) {
						this.isDisabled = false;
						this.submitted = false;
						Swal.fire({
							icon: 'success',
							title: 'Success!',
							text: 'your progress report is submitted successfully on ' + formatDate(new Date(), 'dd-MM-YYYY', 'en') + '.',
							customClass: {
								confirmButton: 'btn btn-success'
							}
						});
						this._router.navigate(['/my-application']);
					}
					else {
						//this.error = response["message"];
						this.isDisabled = false;
						this.loading = false;
						Swal.fire({
							icon: 'error',
							title: 'Error!',
							text: response["message"],
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				},
				error => {
					//this.error = error;
					this.isDisabled = false;
					this.loading = false;
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: error,
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			);

		return false;
	}

	public prepareSave(): any {
		console.log(this.progressReportForm.controls);
		let input: FormData = new FormData();
		var equipmentProcurementArray = this.equipmentProcurementForm.value.equipmentProcurementArray;
		var manpowerArrayList = this.manpowerForm.value.manpowerArray;
		input.append('applyonlineId', this.ID);
		input.append('projectTitle', this.progressReportForm.controls.Projecttitles.value);
		input.append("actualExpenditure", this.progressReportForm.controls.actualExpenditure.value);
		input.append("addressOfPi", this.progressReportForm.controls.addressOfPi.value);
		input.append("applicationPotential", this.progressReportForm.controls.applicationPotential.value);
		input.append("approvedObject", this.progressReportForm.controls.approvedObject.value);
		input.append("detailedProgress", this.progressReportForm.controls.detailedProgress.value);
		input.append("financialStatus", this.progressReportForm.controls.financialStatus.value);
		input.append("innovations", this.progressReportForm.controls.innovations.value);
		input.append("nameOfPi", this.progressReportForm.controls.nameOfPi.value);
		input.append("newObservation", this.progressReportForm.controls.newObservation.value);
		input.append("outputProject", this.progressReportForm.controls.outputProject.value);
		input.append("projectWorkPlan", this.progressReportForm.controls.projectWorkPlan.value);
		// input.append("projectbudget", this.progressReportForm.controls.projectbudget.value);
		let end_Date = this.progressReportForm.controls.projectendDate.value;
		if (end_Date != null && end_Date != undefined) {
			end_Date = end_Date.year + '-' + end_Date.month + '-' + end_Date.day;
		}
		input.append("projectendDate", end_Date);
		let start_Date = this.progressReportForm.controls.projectstartDate.value;
		if (start_Date != null && start_Date != undefined) {
			start_Date = start_Date.year + '-' + start_Date.month + '-' + start_Date.day;
		}
		input.append("projectstartDate",start_Date);
		input.append("sanctionNumber", this.progressReportForm.controls.sanctionOrderNo.value);
		let sanction_Date = this.progressReportForm.controls.sanctionOrderDate.value;
		if (sanction_Date != null && sanction_Date != undefined) {
			sanction_Date = sanction_Date.year + '-' + sanction_Date.month + '-' + sanction_Date.day;
		}
		input.append("sanctionDate", sanction_Date);
		input.append("sanctionamount", this.progressReportForm.controls.sanctionAmount.value);
		input.append("sanctionOrderDate", sanction_Date);
		input.append("sanctionOrderNo", this.progressReportForm.controls.sanctionOrderNo.value);
		input.append('equipmentProcurementArray', equipmentProcurementArray.length > 0 ? JSON.stringify(equipmentProcurementArray) : "");
		input.append('manpowerArrayList', manpowerArrayList.length > 0 ? JSON.stringify(manpowerArrayList) : "");

		input.append("summary", this.progressReportForm.controls.summary.value);
		// input.append("technicalReport", this.progressReportForm.controls.technicalReport.value);

		for (var i = 0; i < this.documentFilesSOE.length; i++) {
			input.append(this.documentFilesSOE[i].key, this.documentFilesSOE[i].file);
		}
		for (var i = 0; i < this.documentFiles.length; i++) {
			input.append(this.documentFiles[i].key, this.documentFiles[i].file);
		}
		for (var i = 0; i < this.documentFilesOthers.length; i++) {
			input.append(this.documentFilesOthers[i].key, this.documentFilesOthers[i].file);
		}
		for (var i = 0; i < this.documentFilesTechnical.length; i++) {
			input.append(this.documentFilesTechnical[i].key, this.documentFilesTechnical[i].file);
		}
		return input;
	}
	/**
	 * Get FormData
	 */
	get formDetails() {
		return this.progressReportForm.controls;
	}

	getProgressReportDetails(id) {
		const data = {
			applyonlineId: id
		}
		this._myApplicationService.getPendingProgressReportData(data).subscribe((result: any) => {
			this.reportDetails = null;
			if (result.statusCode == statusCode.SUCCESS) {
				this.reportDetails = result["data"]["response"]["progressReportDetails"];
				this.equipmentDetails = result["data"]["response"]["prEquipmentDetails"];
				this.manPowerDetails = result["data"]["response"]["manPowerDetails"];
			}
			if (this.reportDetails != undefined) {
				this.progressReportForm.controls['addressOfPi'].setValue(this.reportDetails.AddressOfPI);
				this.progressReportForm.controls['actualExpenditure'].setValue(this.reportDetails.actualExpenditure);
				this.progressReportForm.controls['approvedObject'].setValue(this.reportDetails.approvedObjectivesProject);
				this.progressReportForm.controls['outputProject'].setValue(this.reportDetails.outputApprovedProject);
				this.progressReportForm.controls['summary'].setValue(this.reportDetails.summaryProgressReported);
				this.progressReportForm.controls['detailedProgress'].setValue(this.reportDetails.detailedProgress);
				this.progressReportForm.controls['newObservation'].setValue(this.reportDetails.newObservations);
				this.progressReportForm.controls['innovations'].setValue(this.reportDetails.innovations);
				this.progressReportForm.controls['applicationPotential'].setValue(this.reportDetails.applicationPotential);
				this.progressReportForm.controls['projectWorkPlan'].setValue(this.reportDetails.projectAndWorkPlan);
				this.progressReportForm.controls['financialStatus'].setValue(this.reportDetails.statusFinancialYearwise);
				this.otherDocument = this.reportDetails.otherDocument;
				this.technicalReport = this.reportDetails.technicalReport;
				this.UCletter = this.reportDetails.UCletter;
				this.SOEletter = this.reportDetails.SOEletter;
			}
			this.equipmentpatch()
			this.manPowerpatch()
		})
		this._myApplicationService.getReleasedProgressReportData(data).subscribe((result: any) => {
			this.releasedReportDetails = null;
			if (result.statusCode == statusCode.SUCCESS) {
				this.releasedReportDetails = result["data"]["response"];
			}
			console.log(this.releasedReportDetails);
		})
	}
	equipmentpatch() {
		const EquipmentArray = <FormArray>this.equipmentProcurementForm.controls['equipmentProcurementArray'];
		if (this.equipmentDetails.length == 0) {
			this.equipmentProcurementForm = new FormGroup({
				equipmentProcurementArray: this._formBuilder.array([
					this._formBuilder.group({
						sanctionitem: [null, [Validators.required]],
						procurementStatus: ['Yes', [Validators.required]],
						cost: [null, [Validators.required]],
						workingOrNot: ['Yes', [Validators.required]],
						remarks: [null, [Validators.required]]
					})
				])
			})
		} else {
			this.equipmentDetails.forEach(x => {
				EquipmentArray.push(this.equipmentpatchValues(x.sanctionItemsOfEquipment, x.procurementStatus, x.equipmentCost, x.workingStatus, x.remarks))
			})
		}
	}
	equipmentpatchValues(sanctionItemsOfEquipment, procurementStatus, equipmentCost, workingStatus, remarks) {
		return this.fb.group({
			sanctionitem: [sanctionItemsOfEquipment],
			procurementStatus: [procurementStatus],
			cost: [equipmentCost],
			workingOrNot: [workingStatus],
			remarks: [remarks]
		})
	}
	manPowerpatch() {
		const ManpowerArray = <FormArray>this.manpowerForm.controls['manpowerArray'];
		if (this.manPowerDetails.length == 0) {
			this.manpowerForm = new FormGroup({
				manpowerArray: this._formBuilder.array([
					this._formBuilder.group({
						sanctionedlist: [null, [Validators.required]],
						position: ['Yes', [Validators.required]],
						scale: [null, [Validators.required]],
						manpowerRemarks: [null, [Validators.required]]
					})
				])
			});
		} else {
			this.manPowerDetails.forEach(x => {
				ManpowerArray.push(this.manPowerpatchValues(x.sanctionList, x.inPosition, x.scale, x.remarks))
			})
		}
	}
	manPowerpatchValues(sanctionList, inPosition, scale, remarks) {
		return this.fb.group({
			sanctionedlist: [sanctionList],
			position: [inPosition],
			scale: [scale],
			manpowerRemarks: [remarks]
		})
	}
}
